import { render, staticRenderFns } from "./Tab-Driver.vue?vue&type=template&id=11a0a70b"
import script from "./Tab-Driver.vue?vue&type=script&lang=js"
export * from "./Tab-Driver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports